module.exports = __webpack_public_path__ + "img/lovoo.8c561ae.webp";